import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "var(--smar--ursa-icons--backgroundColor, transparent)",
  d: "M7 8a4 4 0 0 1 4-4h2a4 4 0 0 1 4 4v8a4 4 0 0 1-4 4h-2a4 4 0 0 1-4-4z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M6.07 6.928C6.07 4.692 8.057 3 10.352 3s4.281 1.692 4.281 3.928v7.839c0 .666-.225 1.306-.674 1.785-.453.485-1.096.764-1.842.766-.75.003-1.396-.274-1.851-.762-.449-.481-.671-1.123-.671-1.79V7.39a.7.7 0 0 1 1.4 0v7.378c0 .359.118.645.295.835.17.182.434.318.821.316.387 0 .653-.138.826-.322.178-.191.296-.476.296-.83V6.929c0-1.33-1.22-2.528-2.881-2.528C8.69 4.4 7.47 5.598 7.47 6.928v8.76c0 2.08 1.944 3.912 4.53 3.912s4.53-1.832 4.53-3.911v-8.3a.7.7 0 1 1 1.4 0v8.3C17.93 18.702 15.19 21 12 21s-5.93-2.298-5.93-5.311z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=AttachFileIcon24.js.map